import { useEffect } from 'react';
import { dispatchAction } from '@ardoq/rxbeach';
import { AddListener } from '../modalDropdownTypes';
import { moveHighlightRequested, enterPressed } from './customSelectActions';
import { isMac } from '@ardoq/common-helpers';

export const useSubscribeToKeyboardListener = ({
  addKeyboardListener,
  removeKeyboardListener,
  actionNamespace,
}: {
  addKeyboardListener: AddListener;
  removeKeyboardListener: AddListener;
  actionNamespace?: string;
}) => {
  useEffect(() => {
    // TODO use namespace for actions
    const onKeyDown = (event: KeyboardEvent) => {
      switch (event.key) {
        case 'ArrowUp':
        case 'Up':
          event.preventDefault();
          dispatchAction(moveHighlightRequested(-1), actionNamespace);
          break;

        case 'ArrowDown':
        case 'Down':
          event.preventDefault();
          dispatchAction(moveHighlightRequested(1), actionNamespace);
          break;

        case 'Enter':
          event.preventDefault();
          dispatchAction(
            enterPressed({
              withMetaKey: isMac() ? event.metaKey : event.ctrlKey,
            }),
            actionNamespace
          );
          break;
      }
      // To cancel event handling return false.
      return true;
    };
    addKeyboardListener(onKeyDown);

    return () => removeKeyboardListener(onKeyDown);
  }, [addKeyboardListener, removeKeyboardListener, actionNamespace]);
};
